<template>
    <div>
        <div
            class="btn-wrapper d-flex justify-content-md-end justify-content-center new-contract-from-employee-top-buttons">
            <button class="btn btn-outline-primary wizard-btn prev-btn" @click="previous">
                <i class="fa fa-arrow-left" aria-hidden="true"></i>
                {{ $t("global.return") }}
            </button>
            <button class="btn btn-primary wizard-btn next-btn" @click="nextStep">
                {{ $t("global.save") }}
            </button>
        </div>
        <div class="card card-small mb-4 mt-3">
            <div class="card-body">
                <div class="py-2 px-3">
                    <div class="row">
                        <div class="col-lg-6">
                            <div>
                            <div>
                                <div class="five">
                                <div class="row d-flex flex-wrap align-items-stretch">
                                    <div class="col-md-6" v-for="field in fields">
                                        <div class="step4-card">
                                            <div class="row">
                                                <svg-icon />
                                                <div class="col-10">
                                                    <p>{{ field.label }} :</p>
                                                    <span v-if="field.key === 'typeOfContract' && model.typeOfContract === 'OTHER'">
                                                    {{ model.otherContract }}
                                                    </span>
                                                    <span v-else>{{ getValue(field.key) }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <h5 class="mt-3">Remarques :</h5>
                            <span>{{ model.Remarques }}</span>
                        </div>
                        <div class="col-12">
                            <div class="row">
                            <button class="download-document-button" @click="downloadUpload(model.IDPath)">
                                <i class="fa fa-paperclip fa-lg mr-2" aria-hidden="true"></i>Pièce d'identité
                            </button>
                            <button class="download-document-button" @click="downloadUpload(model.CVPath)">
                                <i class="fa fa-paperclip fa-lg mr-2" aria-hidden="true"></i>Carte vitale
                            </button>
                            <button v-for="doc in model.otherDocumentsPaths" class="download-document-button" @click="downloadUpload(doc.path)">
                                <i class="fa fa-paperclip fa-lg mr-2" aria-hidden="true"></i>{{ doc.name }}
                            </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SvgIcon from "../../../components/shared/SvgIcon.vue";
import { storage } from "../../../firebase/app";
import { ref, getDownloadURL } from "firebase/storage";
import contractType from "../../../data/contract/contractType";

export default {
    name: "StepThree",
    components: { SvgIcon },
    props: ["model"],
    data() {
        return {
            contractType,
            fields: [
                { label: 'Nom', key: 'lastName' },
                { label: 'Prénom', key: 'firstName' },
                { label: 'Titre', key: 'isMale', value: (model) => model.isMale ? 'Monsieur' : 'Madame' },
                { label: 'Date de naissance', key: 'dateOfBirth', value: (model) => model.dateOfBirth ? new Date(model.dateOfBirth).toLocaleDateString('fr-FR') : new Date(model.dateOfBirth).toLocaleDateString('fr-FR') },
                { label: 'Lieu de naissance', key: 'birthPlace' },
                { label: 'Nationalité', key: 'nationality' },
                { label: 'Tél.', key: 'phoneNumber' },
                { label: 'Adresse', key: 'address' },
                { label: 'Adresse mail', key: 'email' },
                { label: 'Code postal', key: 'postalCode' },
                { label: 'Ville', key: 'city' },
                { label: 'Numéro de sécurité sociale', key: 'socialSecurityNumber' },
                { label: 'Numéro Pôle Emploi', key: 'poleEmploiInscriptionNumber' },
                { label: 'Date de début', key: 'dateFrom', value: (model) => new Date(model.dateFrom).toLocaleDateString('fr-FR') },
                { label: 'Date de fin', key: 'dateTo', value: (model) => model.dateTo ? new Date(model.dateTo).toLocaleDateString('fr-FR') : '' },
                { label: 'Type de contrat', key: 'typeOfContract', value: (model) => this.contractType[model.type].name},
                { label: 'Dossier à jour', key: 'upToDate', value: (model) => model.upToDate ? 'Oui' : 'Non' },
                { label: 'Structure', key: 'structureName', value: (model) => model.structureName ? model.structureName : model.selectedStructure.name },
                { label: 'Fonction', key: 'fonction', condition: (model) => model.type !== 'CEE' },
                { label: 'Type de CEE', key: 'CEEType', condition: (model) => model.type === 'CEE' },
                { label: 'Nombre de jours du contrat', key: 'daysOfContract' },
                { label: "Nombre de jour(s) travaillé(s) en qualité d'engagé éducatif sur les 11 derniers mois", key: 'daysOfContractPast11Months', condition: (model) => model.type === 'CEE' },
            ],
        };
    },
    methods: {
        downloafUpload(pathToFile) {
            getDownloadURL(ref(storage, pathToFile))
                .then((url) => {
                    const xhr = new XMLHttpRequest();
                    xhr.responseType = "blob";
                    xhr.open("GET", url);
                    xhr.send();
                    xhr.onload = function () {
                        const blob = new Blob([xhr.response]);
                        const a = document.createElement("a");
                        a.href = URL.createObjectURL(blob);
                        a.download = pathToFile;
                        a.click();
                    };
                })
                .catch((error) => {
                    // Handle any errors
                    console.error(error);
                });
        },
        previous() {
            this.$emit("input", null);
        },
        nextStep() {
            this.$emit("input", true);
        },
        getValue(key) {
            let currentField = this.fields.find((field) => field.key === key)
            if (currentField.value) {
                return currentField.value(this.model)
            } else {
                return this.model[key];
            }

        },
    },
};
</script>

<style>
.new-contract-from-employee-top-buttons {
    margin-top: 20px !important;
    margin-right: 20px !important;
}
</style>
